<template>
    <div>

        <main role="main">

            <div class="container">

                <div class="row">
                    <div class="col-md-12">
                        <a class="mt-3 mb-3 d-block" @click="$router.go(-1)">
                            <i class="fa fa-chevron-circle-left"></i> {{$t('text.globals.back')}}
                        </a>
                    </div>
                </div>

                <div v-if="Object.keys(nodeData).length === 0">
                  <div class="row">
                    <div class="co  l-md-12">
                      <div class="alert alert-danger w-100">
                        <i class="fa fa-2x fa-exclamation-triangle d-block float-left mt-1 mr-3"></i> <span class="d-inline-block pt-3">{{ $t('text.documentLongTermStorageDetails.cannotGetLongTermStorageConversionInfo') + '.'}}</span> <br/>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-4">
                    <div class="col-md-6 float-left"><a class="btn btn-primary text-white" @click="() => { $router.push({ name: 'DocumentDetails', params: { id: $route.params.id,} })}">Na podrobnosti dokumenta</a></div>
                    <div class="col-md-6 float-right text-right"><a class="btn btn-primary text-white" @click="() => { $router.push({ name: 'UploadDocumentInLongTermStorageFormat', params: { id: $route.params.id,} })}">Na ročno dodajanje gradiva</a></div>
                  </div>
                </div>

                <div class="row" v-if="Object.keys(longTermStorageNodeData).length > 0">

                    <div class="col-md-12">

                        <h2 class="preventLongStringOutbreak">
                            <i :class="$globalFunctions.getFileTypeIcon(longTermStorageNodeData.mimetype)"></i>

                            {{longTermStorageNodeData.filename}}

                        </h2>
                    </div>

                </div>
                <div class="row">

                    <loading :active.sync="isLoading"
                             :can-cancel="false"
                             :is-full-page="false"></loading>

                    <div class="col-md-8 mb-5">


                        <div v-if="Object.keys(nodeData).length > 0">

                            <loading :active.sync="isLoadingPreview"
                                     :can-cancel="false"
                                     :is-full-page="false"></loading>


                            <div class="card" v-if="getPreviewIframeContent">

                                <div class="card-header">{{$t('text.globals.documentPreview')}}</div>

                                <div class="card-body bg-light"
                                    style="max-height: 1022px; overflow-y: scroll; padding-top: 20px; padding-bottom: 20px;"
                                    v-if="$globalFunctions.getFileTypeFromMimeType(nodeData.content.mimeType) !== 'image' && $globalFunctions.getFileTypeFromMimeType(nodeData.content.mimeType) !== 'video' && $globalFunctions.getFileTypeFromMimeType(nodeData.content.mimeType) !== 'audio'">
                                    <pdf
                                            v-for="i in numPages"
                                            :key="i"
                                            :src="getPreviewIframeContent"
                                            :page="i"
                                            :rotate="0"
                                            style="width: 100%; height: 100%; margin-bottom: 10px"
                                    ></pdf>
                                </div>

                                <div class="card-body bg-light" style="max-height: 1022px; overflow-y: auto;"
                                     v-if="$globalFunctions.getFileTypeFromMimeType(nodeData.content.mimeType) == 'video' || $globalFunctions.getFileTypeFromMimeType(nodeData.content.mimeType) === 'audio'">
                                    <iframe v-if="getPreviewIframeContent" :src="getPreviewIframeContent"
                                            frameborder="0"
                                            width="100%" height="1100" allowfullscreen webkitallowfullscreen></iframe>
                                </div>

                                <div class="card-body bg-light" style="max-height: 1022px; overflow-y: auto;"
                                     v-if="$globalFunctions.getFileTypeFromMimeType(nodeData.content.mimeType) === 'image'">
                                    <img :src="getPreviewIframeContent" class="img-responsive"
                                         style="width: auto; max-width: 100%;"/>
                                </div>

                            </div>
                            <div v-else class="card-body">
                                <div class="alert alert-info mt-3">
                                    <em><i class="fa fa-exclamation-triangle"></i> {{$t('text.globals.documentPreviewNotAvailable')}}</em>
                                </div>
                            </div>


                        </div>
                    </div>


                    <div class="col-md-4 mb-5" v-if="Object.keys(longTermStorageNodeData).length > 0">
                        <div class="row">

                                <div class="col-md-12">
                                    <div class="row">
                                            <div class="col-md-12">
                                                <a class="btn btn-primary btn-sm text-white d-block"
                                                   @click="downloadFile()"><i
                                                        class="fa fa-download"></i> {{$t('text.globals.download')}}</a>
                                            </div>

                                        <div class="col-md-12" v-if="parentNodeData">
                                            <router-link v-if="parentNodeData.properties && parentNodeData.properties['EH:format_gradiva_preverjen'] === true" class="btn btn-success btn-sm text-white d-block mt-2" :to="{name: 'UploadDocumentInLongTermStorageFormat', params: {id: fileId}}"><i class="fa fa-upload"></i> {{$t('text.documentLongTermStorageDetails.documentForLongTermStorageManualAdd')}}</router-link>
                                        </div>

                                    </div>
                                </div>

                        </div>
                    </div>


                </div>
            </div>

        </main>

    </div>
</template>

<script type="text/javascript">
    import Vue from 'vue';
    import SidebarNavigation from '../components/SidebarNavigation';
    import axios from 'axios';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import vSelect from 'vue-select';
    import 'vue-select/dist/vue-select.css';
    import pdf from 'vue-pdf'


    export default {
        name: 'DocumentDetails',
        components: {
            Vue,
            Loading,
            vSelect,
            pdf
        },

        data() {
            return {
                fileId: this.$route.params.id,
                longTermStorageNodeData: {},
                parentNodeData: {},
                page: 1,
                numPages: 0,
                rotate: 0,
                sites: [],
                user: {},
                error: '',
                nodeData: {},
                isLoading: true,
                isLoadingPreview: false,
                fileBlob: null,
                filePreviewBlob: null,
                allMetadataOptions: []
            };
        },

        beforeCreate: function () {
            document.body.className = 'dashboard';
        },

        watch: {
            '$route': function () {
                this.getNode(this.$route.params.id);
            }
        },

        mounted() {
            const _this = this;

            let p1 = _this.$store.dispatch("retrieveAlfrescoDictionary");
            let p2 = _this.$store.dispatch("retrieveAllMetadataOptions");

            Promise.all([p1, p2]).then((values) => {
                _this.allMetadataOptions = _this.$store.getters.getAllMetadataOptions;
                _this.getLongTermStorageNode(_this.fileId);
                _this.getParentNodeData(_this.fileId);
            });

        },

        computed: {
            getPreviewIframeContent() {
                const _this = this;

                if (_this.filePreviewBlob !== null) {

                    if (_this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) !== 'image' && _this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) !== 'video' && _this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) !== 'audio') {
                        pdf.createLoadingTask(window.URL.createObjectURL(_this.filePreviewBlob)).then(pdf => {
                            _this.numPages = pdf.numPages;
                        });
                    }

                    return window.URL.createObjectURL(_this.filePreviewBlob);
                }
            }
        },

        methods: {

            goToDocument(id) {
                this.$router.push({name: 'DocumentDetails', params: {id: id}});
            },

            async getLongTermStorageNode(nodeId) {
                const _this = this;

                await axios.get(config.rootEhramba + 'longTermConverted?nodeId=' + nodeId)
                    .then((res) => {
                        if(res.data) {
                            _this.longTermStorageNodeData = res.data;
                            _this.getNode(res.data.nodeId);
                        } else {
                            Vue.$toast.open({
                                message: this.$t('text.documentLongTermStorageDetails.cannotGetLongTermStorageConversionInfo'),
                                type: 'error',
                                position: 'top-right'
                            });
                            _this.isLoading = false;
                        }
                    })
                    .catch((error) => {
                        console.log("error", error);
                    });
            },

            async getNode(nodeId) {
                const _this = this;

                await axios.get(config.alfrescoCoreApi + 'nodes/' + nodeId)
                    .then((res) => {

                        _this.nodeData = _this.$globalFunctions.getReadableDocumentMetadataCodeListValues(_this.allMetadataOptions, _.cloneDeep(res.data.entry));

                        _this.getFileBlob();

                        _this.isLoading = false;
                        console.log("node data: ", _this.nodeData);



                        if (_this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) === 'pdf' ||
                            _this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) === 'image' ||
                            _this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) === 'audio' ||
                            _this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) === 'video') {
                            _this.showPreview(false);
                            _this.isLoading = false;
                        } else {
                            _this.getFilePreview();
                            _this.isLoading = false;
                            _this.isLoadingPreview = true;
                        }


                        _this.$forceUpdate();

                        //console.log(_this.globalFunctions.getFileTypeIcon(_this.nodeData.content.mimeType));

                    })
                    .catch((error) => {
                        console.error(error);

                        this.isLoading = false;
                    });


            },

            async getParentNodeData(nodeId) {
                const _this = this;

                await axios.get(config.alfrescoCoreApi + 'nodes/' + nodeId)
                    .then((res) => {
                        _this.parentNodeData = _this.$globalFunctions.getReadableDocumentMetadataCodeListValues(_this.allMetadataOptions, _.cloneDeep(res.data.entry));
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            },

            getFileBlob() {
                const _this = this;

                this.isLoading = true;

                axios.get(config.alfrescoCoreApi + 'nodes/' + _this.nodeData.id + '/content?attachment=true', {
                    method: 'GET',
                    responseType: 'blob' //Force to receive data in a Blob Format
                })

                    .then((res) => {

                        console.log("RESPONSE ", res);


                        this.fileBlob = res.data;
                        this.isLoading = false;
                    })
                    .catch((error) => {
                        console.error(error);

                        this.isLoading = false;
                    });

            },

            getFilePreview() {
                const _this = this;

                axios.get(config.alfrescoThumbnails + '/' + _this.nodeData.id + '/content/thumbnails/pdf?c=force', {
                    method: 'GET',
                })
                    .then((res) => {
                        console.log(res);
                        _this.fileBlob = res.data;
                        _this.showPreview(true);
                    })
                    .catch((error) => {
                        console.error(error);
                        _this.isLoadingPreview = false;

                        Vue.$toast.open({
                            message: this.$t('text.globals.documentPreviewNotAvailable'),
                            type: 'error',
                            position: 'top-right'
                        });

                    });
            },

            showPreview(showFromRenditions) {
                const _this = this;

                let getPdfPreview = "";

                if (showFromRenditions) {
                    getPdfPreview = config.alfrescoCoreApi + 'nodes/' + _this.nodeData.id + '/renditions/pdf/content?attachment=true&placeholder=false';
                } else {
                    getPdfPreview = config.alfrescoCoreApi + 'nodes/' + _this.nodeData.id + '/content?attachment=true';
                }


                axios.get(getPdfPreview, {
                    method: 'GET',
                    responseType: 'blob' //Force to receive data in a Blob Format
                })

                    .then((res) => {
                        console.log("RES", res.data);

                        _this.filePreviewBlob = res.data;
                        _this.isLoading = false;
                        _this.isLoadingPreview = false;
                    })
                    .catch((error) => {
                        console.error(error);

                        _this.isLoading = false;
                    });

            },

            downloadFile() {
                const _this = this;

                this.isLoading = true;
                let _thisBlob = null;

                axios.get(config.alfrescoCoreApi + 'nodes/' + _this.nodeData.id + '/content', {
                    method: 'GET',
                    responseType: 'blob' //Force to receive data in a Blob Format
                })

                    .then((res) => {

                        console.log("RESPONSE ", res);


                        _thisBlob = res.data;
                        const url = window.URL.createObjectURL(_this.blobToFile(_thisBlob, _this.longTermStorageNodeData.name));
                        const link = document.createElement('a');

                        link.href = url;
                        link.setAttribute('download', _this.longTermStorageNodeData.filename);
                        link.setAttribute('type', _this.longTermStorageNodeData.mimetype);
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        this.isLoading = false;
                    })
                    .catch((error) => {
                        console.error(error);

                        this.isLoading = false;
                    });


            },

            blobToFile(theBlob, fileName) {
                theBlob.lastModifiedDate = new Date();
                theBlob.name = fileName;
                return theBlob;
            },

            printDocument() {
                const _this = this;

                _this.isLoading = true;

                axios
                    .get(config.reports + 'printDocumentDetails?nodeId=' + _this.nodeData.id, {
                        responseType: "blob"
                    })
                    .then(res => {
                        const url = window.URL.createObjectURL(
                            _this.blobToFile(res.data, "Metapodatki")
                        );
                        const link = document.createElement("a");

                        link.href = url;
                        link.setAttribute("download", "Metapodatki dokumenta.pdf");
                        link.setAttribute("type", "application/pdf");
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        _this.isLoading = false;
                    })
                    .catch(error => {
                        _this.isLoading = false;
                        console.error(error);
                    });
            }


        }


    };
</script>



// WEBPACK FOOTER //
// src/pages/DocumentInLongTermStorageDetails.vue